import PostRemoveButton from "./post-remove-button";

export default PostRemoveButton;